<div class='container'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">User role was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit User Role - {{ this.group.name }}</h1>
    <app-audit-line [data]='this.group'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-user-role-form [userGroup]='this.group' [userGroupPermissions]='this.userGroupPermissions'></app-user-role-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/settings/roles'>Cancel</button>
    </form>
  </div>
</div>
